import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Table from '../common/Table';
import RTSpinner from '../common/RTSpinner';
import RTButton from '../common/RTButton';
import { apiGet } from '../../api/apiClient';
import { formatDateToDDMMYYYY } from '../../utils/dateHelper';
import './ViewAllocatedBeds.css';
import RTPageLayout from '../common/RTPageLayout';

const ViewAllocationHistory = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [allocations, setAllocations] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch past allocation data (status not active)
      const allocationResponse = await apiGet('/allocation?status=AllocationEnded');
      setAllocations(allocationResponse.data);

    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to load allocation history data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handlePGClick = (pgId) => {
    window.open(`/paying-guest/view/${pgId}`, '_blank');
  };

  const handleBuildingClick = (buildingId) => {
    window.open(`/building/view/${buildingId}`, '_blank');
  };

  // Define table columns
  const columns = [
    {
      Header: 'Start Date',
      accessor: 'start_date',
      Cell: ({ value }) => formatDateToDDMMYYYY(value)
    },
    {
      Header: 'End Date',
      accessor: 'end_date',
      Cell: ({ value }) => formatDateToDDMMYYYY(value)
    },
    {
      Header: 'PG Name',
      accessor: 'pg_name',
      Cell: ({ value, row }) => (
        <RTButton
          type="link"
          onClick={() => handlePGClick(row.pg_id)}
          className="rt-link-button"
        >
          {value || 'N/A'}
        </RTButton>
      )
    },
    {
      Header: 'Building',
      accessor: 'building_name',
      Cell: ({ value, row }) => (
        <RTButton
          type="link"
          onClick={() => handleBuildingClick(row.building_id)}
          className="rt-link-button"
        >
          {value || 'N/A'}
        </RTButton>
      )
    },
    {
      Header: 'Room',
      accessor: 'room_name'
    },
    {
      Header: 'Rent Amount',
      accessor: 'rent_amount',
      Cell: ({ value }) => value ? `₹${value.toLocaleString()}` : 'N/A'
    }
  ];

  return (
    <RTPageLayout
      activePath={location.pathname}
      title="Allocation History"
      actions={<>
        <RTButton variant="secondary" onClick={() => window.history.back()}>
          &#8592; Back
        </RTButton>
      </>}
    >
      {loading ? (
        <RTSpinner message="Loading allocation history data..." />
      ) : (
      <>
      {error && (
        <div className="rt-error-message">
          {error}
          <RTButton
            type="primary"
            onClick={fetchData}
            style={{ marginLeft: '10px' }}
          >
            Retry
          </RTButton>
        </div>
      )}

      {/* Allocation History Table */}
      <div className="rt-table-section">
        <Table
          title="Past Allocation Details"
          columns={columns}
          data={allocations}
          showSearch={true}
          exportable={true}
          showPagination={true}
          noDataText="No allocation history found."
          pageSize={20}
        />
      </div>
      </>
      )}
    </RTPageLayout>
  );
};

export default ViewAllocationHistory;
